var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{class:[_vm.iconSize, _vm.color + '--text', _vm.fw, _vm.classProp],attrs:{"icon":_vm.iconName,"color":_vm.color},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }